export default "__VITE_ASSET__DLwqhvjF__"